import React from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Card, Button } from "react-bootstrap";

export default function HomePage() {
  const navigate = useNavigate();

  const sections = [
    {
      title: "CTIS",
      path: "/ctis",
      description: "Preparing, validating, and assembling structured submission packages for CTIS."
    },
    {
      title: "MDR / IVDR",
      path: "/mdr-ivdr",
      description: "Regulatory package planning and workflows for MDR and IVDR."
    },
    {
      title: "Precision Medicine",
      path: "/precision-medicine",
      description: "Data modelling and regulatory assembly for Precision Medicine."
    }
  ];

  return (
    <div className="home-page py-4">
      <Container style={{ maxWidth: "1320px" }}>
        <Row className="g-4">
          {sections.map((section) => (
            <Col xs={12} md={6} xl={4} key={section.title}>
              <Card className="home-card h-100 border-0 shadow-sm">
                <Card.Body className="d-flex flex-column">
                  <div className="home-card-top mb-3">
                    <span className="home-card-label text-uppercase small text-muted fw-bold">
                      Module
                    </span>
                    <h2 className="home-card-title h5 mb-0 fw-bold text-dark">
                      {section.title}
                    </h2>
                  </div>

                  <p className="home-card-text flex-grow-1 text-secondary">
                    {section.description}
                  </p>

                  <div className="pt-3">
                    <Button
                      variant="dark"
                      className="w-100 fw-bold py-2"
                      style={{ fontSize: "0.85rem" }}
                      onClick={() => navigate(section.path)}
                    >
                      OPEN {section.title.toUpperCase()}
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}